export const isFilterable = filter => (typeof filter.filterable === 'boolean' ? filter.filterable : true);

export const getFilterableTagIds = filters => {
  const filterId = Object.keys(filters);
  return filterId.filter(id => filters[id].filterable);
};
